import { getGridDateOperators } from '@mui/x-data-grid-premium';

import { AutocompleteFilterSelector } from '../../../pre-screen/NewWorklist/WorklistTable/CustomFilters/AutocompleteFilterSelector';
import { studyTypeOptionsMap } from '../FinanceFilters/MultiSelectStudyType';

export function overrideBeforeDateOperator(fieldName) {
  const defaultDateOperators = getGridDateOperators();

  return defaultDateOperators.map(op => {
    if (op.value !== 'before') return op;

    return {
      ...op,
      label: op.label ?? 'is before',
      getApplyFilterFn: filterItem => {
        if (!filterItem.value) return null;

        const filterDate = new Date(filterItem.value);
        return (value, row) => {
          if (!row[fieldName]) return false;
          const cellDate = new Date(row[fieldName]);
          return cellDate < filterDate;
        };
      }
    };
  });
}

export const finStudyTypeFilterOperator = [
  {
    label: 'is',
    value: 'is',
    getApplyFilterFn: filterItem => {
      if (!filterItem.field || !filterItem.value || !filterItem.operator) {
        return null;
      }
      return value => {
        return value === filterItem.value.label;
      };
    },
    InputComponent: props => (
      <AutocompleteFilterSelector
        options={studyTypeOptionsMap.map(option => ({ ...option, label: option.name }))}
        label="Type"
        placeholder="Type value"
        {...props}
      />
    )
  }
];
